export const formatGatewayType = (gatewayType: string) => {
  return gatewayType ? String(gatewayType).replace('gateway', '').slice(1) : gatewayType
}
